export const FETCH_COMPANY_MASTER_DDLS = "FETCH_COMPANY_MASTER_DDLS";
